require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 283
// module chunks = 1